import { Directive, Input } from '@angular/core';

import { fileTypeAllowed } from '../validators';

@Directive()
export abstract class BaseFileUploadDirective {
  @Input() disabled = false;
  @Input() accepts: string[] = [];
  @Input() fileSize: number;

  protected fileAllowed(files: FileList): boolean {
    const file = this.selectedFile(files);
    return !this.disabled
      && files.length > 0
      && fileTypeAllowed(file, this.accepts);
  }

  protected selectedFile(files: FileList): File {
    return files.item(0);
  }
}
